module.exports = __webpack_public_path__ + "img/ep-X.23ecad98.jpg";